import React from "react";
import { connect } from "react-redux";
import { Button } from "devextreme-react";
import moment from "moment";
import DataGrid, { Column, Paging, Pager, RemoteOperations, MasterDetail } from "devextreme-react/ui/data-grid";
import ReactDOM from "react-dom";
import LoadingGif from "../../../../../../images/animacion2[18].gif";
import NoDataComponent from "../../../../../Shared/noDataImage";
import SiniestroInfoColumn from "../../../../../Shared/SiniestroInfoColumn";
import { doGetDraft } from "../../PrestacionesEconomicas/actions";
import { doGetDocumentRenta } from "../../../../Trabajador/Siniestros/Siniestro/actions";

const TableDetails = React.memo((props) => (

  <div style={{ textAlign: "left" }}>
    <span style={{ fontSize: 18 }}>
      Periodos de pago
    </span>

    <DataGrid
      className="simpleHeader cursor-disabled"
      showBorders={false}
      showColumnLines={false}
      showRowLines={false}
      dataSource={props.source}
    >
      <Column
        dataField="FechaDesde"
        caption="Fecha desde"
        calculateCellValue={(data) => `${data.FechaDesde ? moment(data.FechaDesde).format("DD/MM/YYYY") : "S/D"}`}
        format="dd/MM/yyyy"
        dataType="date"
      />
      <Column
        dataField="FechaHasta"
        caption="Fecha hasta"
        calculateCellValue={(data) => `${data.FechaHasta ? moment(data.FechaHasta).format("DD/MM/YYYY") : "S/D"}`}
        format="dd/MM/yyyy"
        dataType="date"
      />
      <Column dataField="DiasPagados" caption="Dias pagados" />
      <Column
        dataField="FechaPago"
        caption="Fecha de pago"
        sortIndex={0}
        sortOrder="asc"
        sortingMethod={(v1, v2) => {
          const v1d = moment(v1, "DD-MM-YYYY");
          const v2d = moment(v2, "DD-MM-YYYY");
          if (v1d.isAfter(v2d)) return -1;
          if (v1d.isSame(v2d)) return 0;
          if (v1d.isBefore(v2d)) return 1;
          return 0;
        }}
        calculateCellValue={(data) => `${data.FechaPago ? moment(data.FechaPago).format("DD/MM/YYYY") : "S/D"}`}
      />

      <Column
        dataField="EstadoPago"
        calculateDisplayValue={(data) => data.EstadoPago || "S/D"}
        caption="Estado de pago"
        allowFiltering
        headerFilter={{
          dataSource: [
            { text: "Pendiente", value: "Pendiente" },
            { text: "Pagado", value: "Pagado" },
          ],
        }}
      />

      <Column
        dataField="FormaPago"
        caption="Forma de pago"
        format="currency"
        alignment="right"
        dataType="number"
      />
      <Paging
        defaultPageSize={10}
      />
    </DataGrid>
  </div>
));


class Prestaciones extends React.PureComponent {
  constructor(props) {
    super(props);

    this.tableRef = React.createRef();
  }


  getButton = (element, row) => {
    switch (row.data.EstadoDocumentacion) {
      case "Sin documentacion":
        if (row.data.TieneBorrador) {
          ReactDOM.render(<Button
            text="Borrador"
            type="default"
            className="slimButton"
            onClick={() => this.handleDocument(row)}
          />, element);
        } else {
          ReactDOM.render(<Button
            text="Enviar"
            type="default"
            className="slimButton"
            onClick={() => this.handleDocument(row)}
          />, element);
        }

        break;
      case "Objetado":
        if (row.data.TieneBorrador) {
          ReactDOM.render(<Button
            text="Borrador"
            type="default"
            className="slimButton"
            onClick={() => this.handleDocument(row)}
          />, element);
        } else {
          ReactDOM.render(<Button
            text="Enviar"
            type="default"
            className="slimButton"
            onClick={() => this.handleDocument(row)}
          />, element);
        }

        break;
      case "Cert fisico":
        ReactDOM.render("Certificado físico", element);
        break;
      case "Revision ACHS":
        ReactDOM.render(<Button
          text="Ver"
          type="success"
          className="slimButton"
          onClick={() => this.handleDctos(row)}
        />, element);
        break;
      case "Aceptado":
        ReactDOM.render(<Button
          text="Ver"
          type="success"
          className="slimButton"
          onClick={() => this.handleDctos(row)}
        />, element);
        break;
      default:
        break;
    }
  }
  handleDocument = (row) => {
    const fechaSiniestro = row.data.FechaSiniestro ? row.data.FechaSiniestro : "Wed Dec 12 2018 16:59:01 GMT-0300";
    const UserName = row.data.NombreTrabajador.split(" ");

    const data = {
      idFinancialBenefit: row.data.IdPrestacion, // "00687544", //
      userRut: this.props.userData.RUT,
      companyRut: this.props.companyId,
      employeeRut: row.data.RutTrabajador, // "11764068-K"
      jsonData: this.props.jsonData,
      fechaSiniestro,
      FirstName: UserName[0],
      SecondName: UserName[1] ? UserName[1] : "",
      LastName: UserName[2],
      MotherName: UserName[3] ? UserName[3] : "",

    };
    this.props.dispatch(doGetDraft(data));
  }
  handleDctos = (row) => {
    const { IdPrestacion } = row.data;
    this.props.dispatch(doGetDocumentRenta(IdPrestacion));
  }
  render() {
    return (
      <DataGrid
        dataSource={this.props.data}
        showBorders={false}
        showColumnLines={false}
        showRowLines={false}
        noDataText=""
        className="custom-table empresas color"
        ref={(ref) => { if (ref !== null) this.tableRef = ref.instance; }}
        rowAlternationEnabled
        hoverStateEnabled
        selection={{
          mode: "single",
        }}
        onContentReady={(e) => {
          if (e.component.totalCount() === 0) {
            const config = {};
            config.addClass = "table-margin";
            const noDataSpan = e.component.element().querySelector(".dx-scrollable-wrapper");
            ReactDOM.render(<NoDataComponent config={config} message="Sin Prestaciones económicas" />, noDataSpan);
          }
        }}
        loadPanel={{
          enabled: true,
          showPane: true,
          showIndicator: true,
          indicatorSrc: LoadingGif,
          text: "Cargando...",
        }}
      >

        <MasterDetail
          enabled
          component={React.memo((props) => <TableDetails source={props.data.PeriodoPagos} />)}
        />

        <Column
          caption="Siniestro"
          cellTemplate={(element, row) => (
            <React.Fragment >
              {
                ReactDOM.render(<SiniestroInfoColumn
                  active={row.data.Reposo}
                  title={row.data.TipoSiniestro}
                  subtitle={Number(row.data.IdSiniestro).toString()}
                />, element)
              }

            </React.Fragment>
          )}

        />

        <Column
          dataType="date"
          dataField="FechaSiniestro"
          calculateCellValue={(data) => `${data ? moment(data.FechaSiniestro).format("DD/MM/YYYY") : "S/D"}`}
          format="dd/MM/yyyy"
        />

        <Column
          dataField="IdPrestacion"
          caption="Prestación"
          cellTemplate={(element, props) => (
            <React.Fragment >
              {
                ReactDOM.render(
                  <div className="group-Column">
                    <div
                      className={props.data.TipoPrestacion === "SUBSIDIO DIRECTO" ? "table-label-light-blue" :
                        props.data.TipoPrestacion === "Indemnizacion" ? "table-label-green" :
                          props.data.TipoPrestacion === "Pension" ? "table-label-gray" : null
                      }
                    >
                      {props.data.TipoPrestacion}
                    </div>
                    <div className="text spaceText" >{Number(props.data.IdPrestacion).toString()}</div>
                  </div>
                  , element
                )
              }

            </React.Fragment>
          )}

        />

        <Column
          dataField="EstadoDocumentacion"
          caption="Estado documentación"
          calculateDisplayValue={(data) => data.EstadoDocumentacion || "S/D"}
          cellTemplate={(element, props) => (
            <React.Fragment >
              {
                ReactDOM.render(
                  <div>
                    {props.data.EstadoDocumentacion === "Objetado" && (
                      <div className="objetado"> <div className="iconoObjetado"><i className="material-icons">error_outline</i> </div> {props.data.EstadoDocumentacion}</div>
                    )}
                    {props.data.EstadoDocumentacion !== "Objetado" && (
                      <div> {props.data.EstadoDocumentacion}</div>
                    )}


                  </div>
                  , element
                )
              }

            </React.Fragment>
          )}
        />

        <Column
          caption=""
          cellTemplate={(element, row) => (
            <React.Fragment >
              {this.getButton(element, row)}
            </React.Fragment>
          )}

        />

        <RemoteOperations
          paging
          filtering
          summary={false}
          groupPaging={false}
          grouping={false}
          sorting={false}
        />

        <Paging
          defaultPageSize={20}
        />

        <Pager
          visible
          showInfo
          infoText={(page, total, items) => `Página ${page} de ${total} (${items} resultados)`}
        />
      </DataGrid>
    );
  }
}

const mapStateToProps = (state) => ({
  sucursalId: state.global.sucursalId,
  companyId: state.global.companyId,
  listaPrestaciones: state.prestacionesEmpresa.listaPrestaciones,
  isDownloadLoading: state.prestacionesEmpresa.isDownloadLoading,
  filtrosPrestaciones: state.prestacionesEmpresa.filtrosPrestaciones,
  totalPrestaciones: state.prestacionesEmpresa.totalPrestaciones,
  listaBancos: state.global.listaBancos,
  isLoading: state.documentos.isLoading || state.prestacionesEmpresa.isLoading,
  listaAfp: state.global.listaAfp,
  jsonData: state.prestacionesEmpresa.jsonData,
  userData: state.global.userData,
  selectedTipoPrestacion: state.prestacionesEmpresa.selectedTipoPrestacion,
  mainFilters: state.prestacionesEmpresa.mainFilters,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Prestaciones);
